export const catalogApplication = {
    wifi: [221683, 221685, 216925],
    bluetooth: [237740, 237743, 228284, 221679, 221681, 228301],
};
